module.exports = __webpack_public_path__ + "d57d365b28ed820ee4b9c21d39b7cab1.pdf";